import React, { useState } from 'react';
import RangeSlider from 'react-bootstrap-range-slider';
import { Form } from "react-bootstrap";
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"

export default function UiRangeSlider(props) {
    const [value, setValue] = useState(0);

    return (
        <>
            <div className='sb-range-slider'>
                <UiSingleRow>
                    <UiCol lg="8">
                        <RangeSlider
                            value={value}
                            min={props.min}
                            max={props.max}
                            tooltipPlacement='top'
                            tooltip='on'
                            className='styled-slider slider-progress'
                            onChange={changeEvent => setValue(changeEvent.target.value)}
                        />
                        <div className='sb-min-value mt-2'>{props.min}</div>
                    </UiCol>
                    <UiCol lg="4">
                        <Form.Control value={value} readOnly/>
                        <div className='sb-max-value mt-3'>{props.max}</div>
                    </UiCol>
                </UiSingleRow>

            </div>
        </>
    )
}
